// Show the default loader box
$.showLoader = function () {
    SwalBootstrap.fire({
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        html: `<div class="loader">
            <i class="layer"></i>
            <i class="layer"></i>
            <i class="layer"></i>
        </div>`,
    });
}

// Smooth scroll to specific position
$.scrollTo = function (position, target = 'html, body', duration = 0) {
    $(target).animate({
        scrollTop: position,
    }, duration);
}

// Redirect or reload to specific page
$.redirectTo = function (url) {
    window.location.href = url;
    if (/(^|\B)#(?![0-9_]+\b)([a-zA-Z0-9_]{1,})(\b|\r)/.test(url)) {
        window.location.reload();
    }
}

// Popup new window with settings
$.popupTo = function (url, title) {
    var width = 1024;
    var height = 768;
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);

    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
}
